
import * as React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * Container component for all automation-related pages
 * Renders an Outlet that will display the current child route
 */
const Automation: React.FC = () => {
  console.log('Automation layout rendering with Outlet');
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/20">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgba(148,163,184,0.15)_1px,transparent_0)] [background-size:24px_24px] pointer-events-none" />
      
      <div className="relative">
        <Outlet />
      </div>
    </div>
  );
};

export default Automation;
